import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { initialSliceDataSourceFields, sliceCasesDataSourceFields } from './actions'

interface DataSourceFieldsState {
  dataSourceFields: typeof initialSliceDataSourceFields.dataSourceFields
}

const initialState: DataSourceFieldsState = {
  ...initialSliceDataSourceFields,
}

export const dataSourceFieldsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder).addSlice(sliceCasesDataSourceFields)
})
